import { isEmpty } from 'lodash';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

export const isParent = (question) => {
  return (
    question.question_type === EXAM_QUESTION_TYPES.PARENT ||
    (question.question_type ===
      EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE &&
      isEmpty(question.answers))
  );
};

export const getCorrectnessMap = (isCorrect) => ({
  correct: isCorrect,
  incorrect: !isCorrect,
});

export const isResponseCorrect = (question, questionSolution, response) => {
  if (!question || !response) {
    return false;
  }

  if (
    question.question_type === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
  ) {
    if (!questionSolution) {
      return false;
    }
    const selectedSolutionAnswer = questionSolution.answers.find(
      (answer) => answer.id === response.select_selected_answer
    );
    if (selectedSolutionAnswer && selectedSolutionAnswer.is_correct) {
      return true;
    }
    return false;
  }

  // TODO: marks_final is a denormalized field
  return Number(response.marks_final) >= Number(question.marks);
};
